import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {LogoutState} from '../types';

export const useLogoutStore = create<LogoutState>()(
  devtools(
    (set) => ({
      // Initial State
      actionLogout: false,
      messagesContinue: [],
      typeContinue: '',
      flowContinue: '',

      // Actions
      setGoLogout: (flag) =>
        set({actionLogout: flag}, false, 'logout/setGoLogout'),

      continueChat: (messages) =>
        set({messagesContinue: messages}, false, 'logout/continueChat'),

      continueType: (type) =>
        set({typeContinue: type}, false, 'logout/continueType'),

      continueFlow: (flow) =>
        set({flowContinue: flow}, false, 'logout/continueFlow')
    }),
    {name: 'LogoutStore'}
  )
);

// Selectors
export const selectActionLogout = (state: LogoutState) => state.actionLogout;
export const selectMessagesContinue = (state: LogoutState) =>
  state.messagesContinue;
export const selectTypeContinue = (state: LogoutState) => state.typeContinue;
export const selectFlowContinue = (state: LogoutState) => state.flowContinue;
